import React from 'react'
import { Card, Flex } from 'antd'
import dayjs from 'dayjs'
import _ from 'lodash'
import Title from 'antd/es/typography/Title'
import { BarChart } from '@mui/x-charts'
import { APPOINTMENT_COLORS } from '../../Common/Color'

export default function HourChart ({ appointments }) {
  const format = (hours) => {
    return Object.keys(hours).map((hour) => ({
      name: `${hour}h`,
      patientAppointment: hours[hour].filter(appointment => appointment.type === 'PatientAppointment').length,
      cleaningAppointment: hours[hour].filter(appointment => appointment.type === 'CleaningAppointment').length,
      maintenanceAppointment: hours[hour].filter(appointment => appointment.type === 'MaintenanceAppointment').length,
      workAppointment: hours[hour].filter(appointment => appointment.type === 'WorkAppointment').length
    }))
  }

  const hours = _.groupBy(appointments, (appointment) => {
    return dayjs(appointment.begin_date).format('H')
  })

  return (
    <Card>
      <Flex vertical>
        <Title level={5} style={{ textAlign: 'center' }}>
          {'Nombre de RDV par heure'}
        </Title>
        <BarChart
          dataset={format(hours)}
          xAxis={[{ scaleType: 'band', dataKey: 'name' }]}
          series={[
            { dataKey: 'patientAppointment', label: 'Patient', stack: 'total' },
            { dataKey: 'cleaningAppointment', label: 'Nettoyage', stack: 'total' },
            { dataKey: 'maintenanceAppointment', label: 'Maintenance', stack: 'total' },
            { dataKey: 'workAppointment', label: 'Animation', stack: 'total' }
          ]}
          colors={[APPOINTMENT_COLORS.PatientAppointment, APPOINTMENT_COLORS.CleaningAppointment, APPOINTMENT_COLORS.MaintenanceAppointment, APPOINTMENT_COLORS.WorkAppointment]}
          height={200} />
      </Flex>
    </Card>
  )
}
